<template>
  <div
    class="ce-documentResults-group"
    :class="{'group-open': groupOpen}">
    <div v-if="!hasMultipleAssets">
      <DocumentResultMsdsAsset
        v-if="firstAsset.type === 'virtual_msds'"
        class="ce-documentResults-level2"
        :key="`virtual_${firstAsset.id}`"
        :product="product"
        :asset="firstAsset" />

      <DocumentResultAsset
        v-else
        class="ce-documentResults-level2"
        :key="firstAsset.id"
        :asset="firstAsset"
        :product="product" />
    </div>
    <div
      v-else>
      <div class="ce-searchResult-documentAsset ce-documentResults-level2">
        <div class="ce-documentResults-col ce-col1">
          <div class="ce-documentResult-rowToggle">
            <a
              href=""
              @click.prevent="toggleGroup">
              <fa-icon icon="angle-down" />
            </a>
          </div>

          <div class="ce-documentResult-selectCta">
            <checkbox
              class="ce-checkbox--small"
              :id="`${assets[0].type}-group`"
              :value="isInBasket"
              :partially-checked="partiallyInBasket"
              @input="toggleBasket"
              :show-label="false" />
          </div>

          <result-state-indicators
            v-if="isMySheets"
            :show-new="hasNewDocuments"
            :show-updated="hasNewDocumentVersions" />
        </div>
        <div
          class="ce-documentResults-col ce-col2"
          @click.prevent="toggleGroup">
          {{ typeLabel }}
        </div>
        <div class="ce-documentResults-col ce-col3" />
        <div class="ce-documentResults-col ce-col4" />
        <div class="ce-documentResults-col ce-col5" />
        <div class="ce-documentResults-col ce-col6" />
      </div>

      <transition
        :css="false"
        @enter="enterAnimation"
        @leave="leaveAnimation">
        <div
          v-if="groupOpen">
          <document-result-asset
            class="ce-documentResults-level3"
            v-for="asset in assets"
            :key="asset.id"
            :asset="asset"
            :locale-level="true"
            :product="product" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DocumentResultGroup from 'mixins/product-sheets/DocumentResultGroup';

export default {
  mixins: [DocumentResultGroup]
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-documentResults-group {
    .ce-documentResult-rowToggle svg {
      transition: all 250ms ease-in-out;
    }

    &:last-child {
      .ce-searchResult-documentAsset {
        border-bottom: 0;
      }
    }

    &.group-open {
      .ce-documentResult-rowToggle svg {
        transform: rotate(180deg);
      }
    }
  }
</style>
